import React from 'react';
import type { Practice } from '../../types';
import { EventAttendancePanel } from '../attendance/EventAttendancePanel';

interface PracticeAttendanceProps {
  practice: Practice;
  teamId: string;
  onClose?: () => void;
}

/**
 * Practice-specific wrapper around the shared EventAttendancePanel.
 * Kept as its own component so PracticeHeader doesn't need to change.
 */
export function PracticeAttendance({ practice, teamId, onClose }: PracticeAttendanceProps) {
  return (
    <EventAttendancePanel
      eventType="practice"
      eventId={practice.id}
      eventDate={practice.date}
      eventTime={practice.start_time}
      teamId={teamId}
      title="Practice Attendance"
      onClose={onClose}
    />
  );
}

export default PracticeAttendance;
